module.exports = __webpack_public_path__ + "img/icon-summer.ab293e47.png";